import React from "react";
import { ExternalLink, Maximize2, FileText } from "react-feather";
import PdfPreview from "./PdfPreview";

/**
 * Réplica do release-note-pdf-preview.tsx do Omnyve.CPU.UI.
 * Mostra o nome do arquivo, um preview reduzido do PDF e os botões
 * "Visualizar PDF" (abre a modal) e "Abrir nova aba".
 */
const getFilename = (fileUrl) => {
  try {
    const url = new URL(fileUrl);
    return decodeURIComponent(url.pathname.split("/").pop() || "release.pdf");
  } catch (e) {
    return "release.pdf";
  }
};

const ReleaseNotePdfPreview = ({ releaseNote, fileUrl, onOpenPreview }) => {
  if (!releaseNote.link) {
    return (
      <div className="release-note-pdf-empty">
        <FileText size={18} />
        PDF não disponível para esta versão.
      </div>
    );
  }

  const filename = getFilename(releaseNote.link);

  const handleOpenNewTab = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="release-note-pdf-card">
      <div className="release-note-pdf-filename">
        <FileText size={16} />
        <span className="filename">{filename}</span>
      </div>
      <div className="release-note-pdf-thumb">
        <PdfPreview fileUrl={fileUrl} />
      </div>
      <div className="release-note-pdf-actions">
        <button
          type="button"
          className="rn-btn rn-btn-primary"
          onClick={onOpenPreview}
        >
          <Maximize2 size={14} />
          Visualizar PDF
        </button>
        <button
          type="button"
          className="rn-btn rn-btn-outline"
          onClick={handleOpenNewTab}
        >
          <ExternalLink size={14} />
          Abrir nova aba
        </button>
      </div>
    </div>
  );
};

export default ReleaseNotePdfPreview;
